import { supabase } from '../../../lib/supabase/client';
import type { Note, NoteFormData } from '../types';

export const noteService = {
  /**
   * Tüm notları getir
   */
  async getNotes(): Promise<Note[]> {
    const { data, error } = await supabase
      .from('notes')
      .select('*')
      .order('is_pinned', { ascending: false })
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Notes fetch error:', error);
      throw error;
    }

    // PostgreSQL'den gelen veriyi frontend formatına çevir
    return (data || []).map(note => ({
      _id: note.id,
      userId: note.user_id,
      title: note.title,
      content: note.content,
      tags: note.tags || [],
      isPinned: note.is_pinned,
      createdAt: note.created_at,
      updatedAt: note.updated_at,
    }));
  },

  /**
   * Tek bir notu getir
   */
  async getNote(id: string): Promise<Note> {
    const { data, error } = await supabase
      .from('notes')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      console.error('Note fetch error:', error);
      throw error;
    }

    return {
      _id: data.id,
      userId: data.user_id,
      title: data.title,
      content: data.content,
      tags: data.tags || [],
      isPinned: data.is_pinned,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  },

  /**
   * Yeni not oluştur
   */
  async createNote(noteData: NoteFormData): Promise<Note> {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      throw new Error('Kullanıcı oturumu bulunamadı');
    }

    const { data, error } = await supabase
      .from('notes')
      .insert({
        user_id: user.id,
        title: noteData.title,
        content: noteData.content,
        tags: noteData.tags || [],
        is_pinned: noteData.isPinned || false,
      })
      .select()
      .single();

    if (error) {
      console.error('Note create error:', error);
      throw error;
    }

    return {
      _id: data.id,
      userId: data.user_id,
      title: data.title,
      content: data.content,
      tags: data.tags || [],
      isPinned: data.is_pinned,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  },

  /**
   * Notu güncelle
   */
  async updateNote(id: string, noteData: Partial<NoteFormData>): Promise<Note> {
    const updateData: any = {};

    if (noteData.title !== undefined) updateData.title = noteData.title;
    if (noteData.content !== undefined) updateData.content = noteData.content;
    if (noteData.tags !== undefined) updateData.tags = noteData.tags;
    if (noteData.isPinned !== undefined) updateData.is_pinned = noteData.isPinned;

    const { data, error } = await supabase
      .from('notes')
      .update(updateData)
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error('Note update error:', error);
      throw error;
    }

    return {
      _id: data.id,
      userId: data.user_id,
      title: data.title,
      content: data.content,
      tags: data.tags || [],
      isPinned: data.is_pinned,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  },

  /**
   * Notu sil
   */
  async deleteNote(id: string): Promise<void> {
    const { error } = await supabase
      .from('notes')
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Note delete error:', error);
      throw error;
    }
  },

  /**
   * Notu sabitle/çöz
   */
  async toggleNotePin(id: string, isPinned: boolean): Promise<Note> {
    return this.updateNote(id, { isPinned });
  },
};

